import { BrowserRouter, Routes, Route } from "react-router-dom";
import FormView from "./routes/FormView";
import NotFound from "./routes/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/preview" element={<FormView mode="preview" />} />
        <Route path="/p/:projectId/f/:formId" element={<FormView />} />
        <Route
          path="/p/:projectId/f/:formId/v/:version"
          element={<FormView />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
